import { Box, CircularProgress, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import React, { useEffect } from 'react';
import { userTypeAtom } from '../utils/AtomConfig';
import { AuthService } from '../utils/AuthService';
import Constants from '../utils/Constants';

export function Logout() {
  const userType = useAtomValue(userTypeAtom);

  useEffect(() => {
    switch (userType) {
      case 'internal':
        window.location.href = Constants.LOGOUT_REDIRECT_URI;
        break;
      case 'external':
        AuthService.Instance.logoutMsal();
        break;
    }
  }, [userType]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5',
      }}
    >
      <CircularProgress size={60} sx={{ color: '#1A237E' }} />
      <Typography variant='h6' sx={{ marginTop: 2, color: '#1A237E' }}>
        Logging out...
      </Typography>
    </Box>
  );
}
